import { render } from "./Onboarding.vue?vue&type=template&id=50ebd3f0&scoped=true&ts=true"
import script from "./Onboarding.vue?vue&type=script&lang=ts"
export * from "./Onboarding.vue?vue&type=script&lang=ts"

import "./Onboarding.vue?vue&type=style&index=0&id=50ebd3f0&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ebd3f0"]])

export default __exports__